import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useTicketLimit(calendarId: string, eventId: string) {
  const [ticketLimit, setTicketLimit] = useState<number | null>(null);
  const [soldTickets, setSoldTickets] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTicketInfo = async () => {
      try {
        // Get ticket limit
        const { data: calendar } = await supabase
          .from('calendars')
          .select('event_ticket_limit')
          .eq('id', calendarId)
          .single();

        if (calendar?.event_ticket_limit) {
          setTicketLimit(calendar.event_ticket_limit);
        }

        // Get sold tickets count
        const { count } = await supabase
          .from('event_tickets')
          .select('id', { count: 'exact', head: true })
          .eq('calendar_id', calendarId)
          .eq('event_id', eventId)
          .eq('status', 'paid');

        setSoldTickets(count || 0);
      } catch (err) {
        console.error('Error fetching ticket info:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTicketInfo();

    // Subscribe to ticket changes
    const subscription = supabase
      .channel('ticket-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'event_tickets',
          filter: `calendar_id=eq.${calendarId},event_id=eq.${eventId}`
        },
        () => {
          fetchTicketInfo();
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [calendarId, eventId]);

  return { ticketLimit, soldTickets, loading };
}